﻿import {Core} from "../Base/Core";
import {NUtils} from "../Utils/NUtils";
import {UISprite} from "./Tools/Base/UISprite";
import {UILabeledIcon} from "./Tools/Base/UILabeledIcon";
import {UIButton} from "./Tools/Base/UIButton";
import {Time} from "../Utils/Unity/Time";

export class StarterPackButton extends UIButton {

    Awake() {
        super.Awake();
        this.onPlayerChanged = this.onPlayerChanged.bind(this);
        this.back = this.addChild(new UISprite("slots/item-gems"));
        this.timerField = this.addChild(new UILabeledIcon({
            label: "",
            backgroundAlpha: 0.5,
            textProps: {
                fitTextTemplate: "00h 00m 00s",
                wordWrap: false,
            }
        }));
        this.endDateTime = 0;
        this.lastUpdateTime = 0;
        this.SetActive(false);
        this.tryToInitialize();

        Core.Player.on("Changed", this.onPlayerChanged);
        this.on("pointertap", () => Core.UI.starterPackPopup.Show());
        this._initTapHighlight(this.back);
    }

    onPlayerChanged() {
        this.tryToInitialize();
    }

    tryToInitialize() {
        if (!Core.Store.IsInitialized) return;
        if (!Core.UI.starterPackPopup.available) return;
        if (!Core.Time.Initialized) return;
        if (Core.Player.Timers.starterPackTime == 0) return;

        let starterPackStartTime = new Date(Core.Player.Timers.starterPackTime).getTime();
        this.endDateTime = starterPackStartTime + 3600 * 24 * 1000;

        if (this.endDateTime > Core.Time.serverTime && Core.Player.StarterPack == 0) {
            this.SetActive(true);
            this.updateTime();
        }
    }

    Init() {
        if (!Core.Store.IsInitialized) return;
        if (!Core.UI.starterPackPopup.available) return;
        if (!Core.Time.Initialized) return;
        if (Core.Player.Timers.starterPackTime == 0) return;

        let starterPackStartTime = new Date(Core.Player.Timers.starterPackTime);
        this.endDateTime = starterPackStartTime + 3600 * 24 * 1000;

        if (this.endDateTime > Core.Time.serverTime && Core.Player.StarterPack != 1) {
            this.SetActive(true);
            this.updateTime();
        }
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);
        let rect = parentRect.clone();
        rect.x = rect.y = 0;

        this.back.fitRect(rect);

        let labelRect = rect.clone().pad(0, -rect.height * 0.35);
        labelRect.y = rect.height * 0.8;
        this.timerField.fitLayout(labelRect);
    }

    Update() {
        if (!Core.UI.starterPackPopup.available) {
            this.SetActive(false);
            return;
        }
        this.lastUpdateTime += Time.deltaTime;
        if (this.lastUpdateTime > 1) {
            this.updateTime();
            this.lastUpdateTime = 0;
        }

        if (Core.Player.StarterPack == 1) {
            this.SetActive(false);
        }
    }

    updateTime() {
        let timeLeft = (this.endDateTime - Core.Time.serverTime) / 1000;
        this.timerField.label = NUtils.FormatSecondsToTime(timeLeft);
        if (timeLeft <= 0) this.SetActive(false);
    }
}
